import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  content: {
    minHeight: '100vh',
    position: 'relative',
  },
  message: {
    [breakpoints.up('sm')]: {
      position: 'fixed',
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    position: 'relative',
    textAlign: 'center',
  },
  action: {
    [breakpoints.up('sm')]: {
      position: 'absolute',
      height: '100%',
      right: 0,
      top: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingTop: spacing(10),
    },
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
}));

const FixedLayout = ({ children, header, infoContent }) => {
  const classes = useStyles();
  const isWithInfoContent = infoContent !== null;

  return (
    <>
      <Box width={1} position={['relative', 'fixed']} zIndex={[1, 999]}>
        {header}
      </Box>
      <Box className={classes.content}>
        {isWithInfoContent && (
          <Box width={[1, 1 / 5]} className={classes.message}>
            {infoContent}
          </Box>
        )}
        <Box width={isWithInfoContent ? [1, 4 / 5] : 1} className={classes.action}>
          {children}
        </Box>
      </Box>
    </>
  );
};

FixedLayout.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  infoContent: PropTypes.node,
};

FixedLayout.defaultProps = {
  infoContent: null,
};

export default FixedLayout;
